import React from 'react';
import PropTypes from 'prop-types';
import Style from './index.less';
import classNames from 'classnames';
import { TDColor, opacityToAlpha } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';
import { EMPTY_EFFECT } from '../preset-util/base-preset-util';
import {
    EffectPropsField,
    DefaultEffectPresetProps,
} from '@src/framework/editor/src/js/constants';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import i18n from '@i18next/i18n';
import { STSchemeColorVal } from '@tencent/slide-sdk-model';
import { IClrScheme } from '@src/slide/domain/ui-model/element-modeles/Interface/theme-model.interface';
import { generate } from 'shortid';
import Tooltip from '@tencent/dui/lib/components/Tooltip';
import { PresetElementType } from '@src/framework/workbench/const/preset-element-type';
import { IMAGE_PRESET_ICONS, SHAPE_PRESET_ICONS, TEXT_PRESET_ICONS } from './preset-icons';

const defaultGlowProps = {
    ...DefaultEffectPresetProps[ActionType.GLOW],
    [EffectPropsField.COLOR.name]: '#0E0E0E',
    [EffectPropsField.TD_COLOR.name]: new TDColor({ rgbaStr: '#0E0E0E' }),
};

const presetList = [
    { key: `glow-${STSchemeColorVal.accent1}-5`, title: i18n.t('发光：{0}磅，主题色{1}', { 0: 5, 1: 1 }), colorVal: STSchemeColorVal.accent1, size: 5, opacity: 0.6 },
    { key: `glow-${STSchemeColorVal.accent2}-5`, title: i18n.t('发光：{0}磅，主题色{1}', { 0: 5, 1: 2 }), colorVal: STSchemeColorVal.accent2, size: 5, opacity: 0.6 },
    { key: `glow-${STSchemeColorVal.accent3}-5`, title: i18n.t('发光：{0}磅，主题色{1}', { 0: 5, 1: 3 }), colorVal: STSchemeColorVal.accent3, size: 5, opacity: 0.6 },
    { key: `glow-${STSchemeColorVal.accent4}-5`, title: i18n.t('发光：{0}磅，主题色{1}', { 0: 5, 1: 4 }), colorVal: STSchemeColorVal.accent4, size: 5, opacity: 0.6 },
    { key: `glow-${STSchemeColorVal.accent5}-5`, title: i18n.t('发光：{0}磅，主题色{1}', { 0: 5, 1: 5 }), colorVal: STSchemeColorVal.accent5, size: 5, opacity: 0.6 },
    { key: `glow-${STSchemeColorVal.accent6}-5`, title: i18n.t('发光：{0}磅，主题色{1}', { 0: 5, 1: 6 }), colorVal: STSchemeColorVal.accent6, size: 5, opacity: 0.6 },
    { key: `glow-${STSchemeColorVal.accent1}-8`, title: i18n.t('发光：{0}磅，主题色{1}', { 0: 8, 1: 1 }), colorVal: STSchemeColorVal.accent1, size: 8, opacity: 0.6 },
    { key: `glow-${STSchemeColorVal.accent2}-8`, title: i18n.t('发光：{0}磅，主题色{1}', { 0: 8, 1: 2 }), colorVal: STSchemeColorVal.accent2, size: 8, opacity: 0.6 },
    { key: `glow-${STSchemeColorVal.accent3}-8`, title: i18n.t('发光：{0}磅，主题色{1}', { 0: 8, 1: 3 }), colorVal: STSchemeColorVal.accent3, size: 8, opacity: 0.6 },
    { key: `glow-${STSchemeColorVal.accent4}-8`, title: i18n.t('发光：{0}磅，主题色{1}', { 0: 8, 1: 4 }), colorVal: STSchemeColorVal.accent4, size: 8, opacity: 0.6 },
    { key: `glow-${STSchemeColorVal.accent5}-8`, title: i18n.t('发光：{0}磅，主题色{1}', { 0: 8, 1: 5 }), colorVal: STSchemeColorVal.accent5, size: 8, opacity: 0.6 },
    { key: `glow-${STSchemeColorVal.accent6}-8`, title: i18n.t('发光：{0}磅，主题色{1}', { 0: 8, 1: 6 }), colorVal: STSchemeColorVal.accent6, size: 8, opacity: 0.6 },
    { key: `glow-${STSchemeColorVal.accent1}-11`, title: i18n.t('发光：{0}磅，主题色{1}', { 0: 11, 1: 1 }), colorVal: STSchemeColorVal.accent1, size: 11, opacity: 0.6 },
    { key: `glow-${STSchemeColorVal.accent2}-11`, title: i18n.t('发光：{0}磅，主题色{1}', { 0: 11, 1: 2 }), colorVal: STSchemeColorVal.accent2, size: 11, opacity: 0.6 },
    { key: `glow-${STSchemeColorVal.accent3}-11`, title: i18n.t('发光：{0}磅，主题色{1}', { 0: 11, 1: 3 }), colorVal: STSchemeColorVal.accent3, size: 11, opacity: 0.6 },
    { key: `glow-${STSchemeColorVal.accent4}-11`, title: i18n.t('发光：{0}磅，主题色{1}', { 0: 11, 1: 4 }), colorVal: STSchemeColorVal.accent4, size: 11, opacity: 0.6 },
    { key: `glow-${STSchemeColorVal.accent5}-11`, title: i18n.t('发光：{0}磅，主题色{1}', { 0: 11, 1: 5 }), colorVal: STSchemeColorVal.accent5, size: 11, opacity: 0.6 },
    { key: `glow-${STSchemeColorVal.accent6}-11`, title: i18n.t('发光：{0}磅，主题色{1}', { 0: 11, 1: 6 }), colorVal: STSchemeColorVal.accent6, size: 11, opacity: 0.6 },
    { key: `glow-${STSchemeColorVal.accent1}-18`, title: i18n.t('发光：{0}磅，主题色{1}', { 0: 18, 1: 1 }), colorVal: STSchemeColorVal.accent1, size: 18, opacity: 0.6 },
    { key: `glow-${STSchemeColorVal.accent2}-18`, title: i18n.t('发光：{0}磅，主题色{1}', { 0: 18, 1: 2 }), colorVal: STSchemeColorVal.accent2, size: 18, opacity: 0.6 },
    { key: `glow-${STSchemeColorVal.accent3}-18`, title: i18n.t('发光：{0}磅，主题色{1}', { 0: 18, 1: 3 }), colorVal: STSchemeColorVal.accent3, size: 18, opacity: 0.6 },
    { key: `glow-${STSchemeColorVal.accent4}-18`, title: i18n.t('发光：{0}磅，主题色{1}', { 0: 18, 1: 4 }), colorVal: STSchemeColorVal.accent4, size: 18, opacity: 0.6 },
    { key: `glow-${STSchemeColorVal.accent5}-18`, title: i18n.t('发光：{0}磅，主题色{1}', { 0: 18, 1: 5 }), colorVal: STSchemeColorVal.accent5, size: 18, opacity: 0.6 },
    { key: `glow-${STSchemeColorVal.accent6}-18`, title: i18n.t('发光：{0}磅，主题色{1}', { 0: 18, 1: 6 }), colorVal: STSchemeColorVal.accent6, size: 18, opacity: 0.6 },
];

interface GlowPresetMenuProps {
    onGlowPresetStyleMouseEnter: (value) => void;
    onGlowPresetStyleClick: (value) => void;
    onGlowPresetStyleMouseLeave: () => void;
    preset: any;
    id?: string;
    presetElementType?: PresetElementType;
    themeColors?: IClrScheme;
}
export default class GlowPresetMenu extends React.Component<GlowPresetMenuProps> {
    public static defaultProps = {};
    public static propTypes = {
        preset: PropTypes.object.isRequired,
        onGlowPresetStyleClick: PropTypes.func.isRequired,
        onGlowPresetStyleHover: PropTypes.func,
        onGlowPresetStyleMouseEnter: PropTypes.func.isRequired,
        onGlowPresetStyleMouseLeave: PropTypes.func.isRequired,
    };

    public render() {
        const icons = this.getPresetIcons();
        return (
            <div className={classNames(Style.container, 'glow-preset')} style={{ width: 356 }}>
                <div className={Style['glow-type-title']}>{i18n.t('无发光')}</div>
                <div className={Style['glow-collection']}>
                    <div className={classNames({
                        [Style['glow-collection-item']]: true,
                        [Style['glow-item-selected']]: EMPTY_EFFECT === this.props.preset.style,
                    })}
                    onClick={() => this.handleGlowPresetIconClick('glow-empty-click')}
                    onMouseEnter={() => this.handleGlowPresetIconMouseEnter('glow-empty-hover')}
                    onMouseLeave={() => this.handleGlowPresetIconMouseLeave()}
                    >
                        <Tooltip placement={['top', 'right']} title={i18n.t('无')}>
                            <div className={Style['preset-icon']}>
                                <img src={icons[EMPTY_EFFECT]}/>
                            </div>
                        </Tooltip>
                    </div>
                </div>
                <div className={Style['glow-type-title']}>{i18n.t('发光')}</div>
                <div className={Style['glow-collection']} style={ { gridTemplateColumns: 'repeat(6, 48px)' } }>
                    {presetList.map(item => this.renderGlowPresetIcon(item))}
                </div>
            </div>
        );
    }

    private getPresetIcons = () => {
        if (this.props.presetElementType === PresetElementType.IMAGE) {
            return IMAGE_PRESET_ICONS;
        }
        if (this.props.presetElementType === PresetElementType.TEXT) {
            return TEXT_PRESET_ICONS;
        }
        return SHAPE_PRESET_ICONS;
    };

    private renderGlowPresetIcon(item) {
        const isSelected = (item.style ?? item.key) === this.props.preset.style;
        const glowItemClass = classNames({
            [Style['glow-collection-item']]: true,
            [Style['glow-item-selected']]: isSelected,
        });
        return (
            <div
                key={item.key}
                className={glowItemClass}
                onMouseEnter={() => this.handleGlowPresetIconMouseEnter((item.style ?? item.key))}
                onClick={() => this.handleGlowPresetIconClick((item.style ?? item.key))}
                onMouseLeave={() => this.handleGlowPresetIconMouseLeave()}
            >
                <Tooltip placement={['top', 'right']} title={i18n.t(item.title)}>
                    <div className={Style['preset-icon']}>
                        {this.getGlowPresetIcon(item.size, item.colorVal)}
                    </div>
                </Tooltip>
            </div>
        );
    }

    private handleGlowPresetIconMouseEnter = (style) => {
        const pictureValue = Object.fromEntries(presetList.map(item => [item.key, this.getPresetProps(item)]));
        const value = pictureValue[style];
        this.props.onGlowPresetStyleMouseEnter(value ? { ...value } : value);
    };

    private handleGlowPresetIconClick = (style) => {
        const pictureValue = Object.fromEntries(presetList.map(item => [item.key, this.getPresetProps(item)]));
        const value = pictureValue[style];
        this.props.onGlowPresetStyleClick(value ? { ...value } : value);
    };

    private getPresetProps = item => ({
        ...defaultGlowProps,
        color: `#${this.props.themeColors?.[item.colorVal]}`,
        [EffectPropsField.TD_COLOR.name]: new TDColor({ themeKey: item.colorVal, alpha: opacityToAlpha(60) }),
        [EffectPropsField.SIZE.name]: item.size,
    });

    private handleGlowPresetIconMouseLeave = () => {
        this.props.onGlowPresetStyleMouseLeave();
    };

    private hexToMatrix(hex = '', a = 0.6) {
        hex = hex.replace('#', '');

        // 将十六进制颜色值转换为 RGB 值
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);

        // 将 RGB 值归一化到 0-1 的范围
        const rNorm = r / 255;
        const gNorm = g / 255;
        const bNorm = b / 255;

        // 构建颜色矩阵
        const matrix = [
            0, 0, 0, 0, rNorm,
            0, 0, 0, 0, gNorm,
            0, 0, 0, 0, bNorm,
            0, 0, 0, a, 0,
        ];

        // 生成矩阵字符串
        const matrixString = matrix.join(' ');
        return matrixString;
    }


    // eslint-disable-next-line complexity
    private getGlowPresetIcon(size: number, colorVal: STSchemeColorVal) {
        const hex = this.props.themeColors?.[colorVal];
        const colorMatrix = this.hexToMatrix(hex);
        const type = this.props.presetElementType;
        if (type === PresetElementType.IMAGE) {
            switch (size) {
                case 5:
                    return this.getImage5ptGlowSvg(colorMatrix);
                case 8:
                    return this.getImage8ptGlowSvg(colorMatrix);
                case 11:
                    return this.getImage11ptGlowSvg(colorMatrix);
                case 18:
                    return this.getImage18ptGlowSvg(colorMatrix);
                default:
                    return this.getImage5ptGlowSvg(colorMatrix);
            }
        } else if (type === PresetElementType.SHAPE) {
            switch (size) {
                case 5:
                    return this.getShape5ptGlowSvg(colorMatrix);
                case 8:
                    return this.getShape8ptGlowSvg(colorMatrix);
                case 11:
                    return this.getShape11ptGlowSvg(colorMatrix);
                case 18:
                    return this.getShape18ptGlowSvg(colorMatrix);
                default:
                    return this.getShape5ptGlowSvg(colorMatrix);
            }
        }
        const hexStr = `#${hex}`;
        switch (size) {
            case 5:
                return this.getText5ptGlowSvg(hexStr);
            case 8:
                return this.getText8ptGlowSvg(hexStr);
            case 11:
                return this.getText11ptGlowSvg(hexStr);
            case 18:
                return this.getText18ptGlowSvg(hexStr);
            default:
                return this.getText5ptGlowSvg(hexStr);
        }
    }

    private getImage5ptGlowSvg = (colorMatrix) => {
        const id = generate();
        const clipId = `#clip${id}`;
        const filterId = `#filter${id}`;
        return <svg width="44" height="44" viewBox="0 0 44 44" version="1.1" xmlns="http://www.w3.org/2000/svg" >
            <g filter={`url(#${filterId})`}>
                <g clipPath={`url(#${clipId})`}>
                    <rect x="6" y="6" width="32" height="32" rx="4" fill="white" style={{ fill: 'white', fillOpacity: 1 }} />
                    <path d="M6 10C6 7.79086 7.79086 6 10 6H34C36.2091 6 38 7.79086 38 10V34C38 36.2091 36.2091 38 34 38H10C7.79086 38 6 36.2091 6 34V10Z" fill="#EDF3FF" style={{ fill: 'color(display-p3 0.9294 0.9529 1.0000)', fillOpacity: 1 }} />
                    <path fillRule="evenodd" clipRule="evenodd" d="M34 7H10C8.34315 7 7 8.34315 7 10V34C7 35.6569 8.34315 37 10 37H34C35.6569 37 37 35.6569 37 34V10C37 8.34315 35.6569 7 34 7ZM10 6C7.79086 6 6 7.79086 6 10V34C6 36.2091 7.79086 38 10 38H34C36.2091 38 38 36.2091 38 34V10C38 7.79086 36.2091 6 34 6H10Z" fill="#9DC0FF" style={{ fill: 'color(display-p3 0.6157 0.7529 1.0000)', fillOpacity: 1 }} />
                    <path fillRule="evenodd" clipRule="evenodd" d="M16.1902 17.2631C17.7566 17.2631 19.0265 16.0275 19.0265 14.5033C19.0265 12.9791 17.7566 11.7435 16.1902 11.7435C14.6238 11.7435 13.3539 12.9791 13.3539 14.5033C13.3539 16.0275 14.6238 17.2631 16.1902 17.2631ZM16.7694 22.3066C16.8369 22.204 16.9856 22.1989 17.06 22.2966L20.626 26.9826C20.6991 27.0788 20.8448 27.0757 20.9139 26.9766L25.9783 19.711C26.0512 19.6063 26.2073 19.61 26.2752 19.718L34.5003 32.8039C34.5748 32.9226 34.4895 33.0769 34.3494 33.0769H10.0155C9.87369 33.0769 9.78873 32.9193 9.86664 32.8008L16.7694 22.3066Z" fill="#8BB4FF" fillOpacity="0.5" style={{ fill: 'color(display-p3 0.5451 0.7059 1.0000)', fillOpacity: 0.5 }} />
                </g>
            </g>
            <defs>
                <filter id={filterId} x="2" y="2" width="40" height="40" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feMorphology radius="1" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_195_19603" />
                    <feOffset />
                    <feGaussianBlur stdDeviation="1.5" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values={colorMatrix} />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_195_19603" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_195_19603" result="shape" />
                </filter>
                <clipPath id={clipId}>
                    <rect x="6" y="6" width="32" height="32" rx="4" fill="white" style={{ fill: 'white', fillOpacity: 1 }} />
                </clipPath>
            </defs>
        </svg>;
    };

    private getImage8ptGlowSvg = (colorMatrix) => {
        const id = generate();
        const clipId = `clip${id}`;
        const filterId = `filter${id}`;
        return (
            <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter={`url(#${filterId})`}>
                    <g clipPath={`url(#${clipId})`}>
                        <rect x="6" y="6" width="32" height="32" rx="4" fill="white" style={{ fill: 'white', fillOpacity: 1 }} />
                        <path d="M6 10C6 7.79086 7.79086 6 10 6H34C36.2091 6 38 7.79086 38 10V34C38 36.2091 36.2091 38 34 38H10C7.79086 38 6 36.2091 6 34V10Z" fill="#EDF3FF" style={{ fill: '#EDF3FF', fillOpacity: 1 }} />
                        <path fillRule="evenodd" clipRule="evenodd" d="M34 7H10C8.34315 7 7 8.34315 7 10V34C7 35.6569 8.34315 37 10 37H34C35.6569 37 37 35.6569 37 34V10C37 8.34315 35.6569 7 34 7ZM10 6C7.79086 6 6 7.79086 6 10V34C6 36.2091 7.79086 38 10 38H34C36.2091 38 38 36.2091 38 34V10C38 7.79086 36.2091 6 34 6H10Z" fill="#9DC0FF" style={{ fill: '#9DC0FF', fillOpacity: 1 }} />
                        <path fillRule="evenodd" clipRule="evenodd" d="M16.1902 17.2631C17.7566 17.2631 19.0265 16.0275 19.0265 14.5033C19.0265 12.9791 17.7566 11.7435 16.1902 11.7435C14.6238 11.7435 13.3539 12.9791 13.3539 14.5033C13.3539 16.0275 14.6238 17.2631 16.1902 17.2631ZM16.7694 22.3066C16.8369 22.204 16.9856 22.1989 17.06 22.2966L20.626 26.9826C20.6991 27.0788 20.8448 27.0757 20.9139 26.9766L25.9783 19.711C26.0512 19.6063 26.2073 19.61 26.2752 19.718L34.5003 32.8039C34.5748 32.9226 34.4895 33.0769 34.3494 33.0769H10.0155C9.87369 33.0769 9.78873 32.9193 9.86664 32.8008L16.7694 22.3066Z" fill="#8BB4FF" fillOpacity="0.5" style={{ fill: '#8BB4FF', fillOpacity: 0.5 }} />
                    </g>
                </g>
                <defs>
                    <filter id={filterId} x="1" y="1" width="42" height="42" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                        <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_195_19606" />
                        <feOffset />
                        <feGaussianBlur stdDeviation="1.5" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix type="matrix" values={colorMatrix} />
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_195_19606" />
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_195_19606" result="shape" />
                    </filter>
                    <clipPath id={clipId}>
                        <rect x="6" y="6" width="32" height="32" rx="4" fill="white" style={{ fill: 'white', fillOpacity: 1 }} />
                    </clipPath>
                </defs>
            </svg>
        );
    };

    private getImage11ptGlowSvg = (colorMatrix) => {
        const id = generate();
        const clipId0 = `clip0_${id}`;
        const clipId1 = `clip1_${id}`;
        const filterId = `filter_${id}`;

        return (
            <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath={`url(#${clipId0})`}>
                    <g filter={`url(#${filterId})`}>
                        <g clipPath={`url(#${clipId1})`}>
                            <rect x="6" y="6" width="32" height="32" rx="4" fill="white" style={{ fill: 'white', fillOpacity: 1 }} />
                            <path d="M6 10C6 7.79086 7.79086 6 10 6H34C36.2091 6 38 7.79086 38 10V34C38 36.2091 36.2091 38 34 38H10C7.79086 38 6 36.2091 6 34V10Z" fill="#EDF3FF" style={{ fill: '#EDF3FF', fillOpacity: 1 }} />
                            <path fillRule="evenodd" clipRule="evenodd" d="M34 7H10C8.34315 7 7 8.34315 7 10V34C7 35.6569 8.34315 37 10 37H34C35.6569 37 37 35.6569 37 34V10C37 8.34315 35.6569 7 34 7ZM10 6C7.79086 6 6 7.79086 6 10V34C6 36.2091 7.79086 38 10 38H34C36.2091 38 38 36.2091 38 34V10C38 7.79086 36.2091 6 34 6H10Z" fill="#9DC0FF" style={{ fill: '#9DC0FF', fillOpacity: 1 }} />
                            <path fillRule="evenodd" clipRule="evenodd" d="M16.1902 17.2631C17.7566 17.2631 19.0265 16.0275 19.0265 14.5033C19.0265 12.9791 17.7566 11.7435 16.1902 11.7435C14.6238 11.7435 13.3539 12.9791 13.3539 14.5033C13.3539 16.0275 14.6238 17.2631 16.1902 17.2631ZM16.7694 22.3066C16.8369 22.204 16.9856 22.1989 17.06 22.2966L20.626 26.9826C20.6991 27.0788 20.8448 27.0757 20.9139 26.9766L25.9783 19.711C26.0512 19.6063 26.2073 19.61 26.2752 19.718L34.5003 32.8039C34.5748 32.9226 34.4895 33.0769 34.3494 33.0769H10.0155C9.87369 33.0769 9.78873 32.9193 9.86664 32.8008L16.7694 22.3066Z" fill="#8BB4FF" fillOpacity="0.5" style={{ fill: '#8BB4FF', fillOpacity: 0.5 }} />
                        </g>
                    </g>
                </g>
                <defs>
                    <filter id={filterId} x="0" y="0" width="44" height="44" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                        <feMorphology radius="3" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_195_19609" />
                        <feOffset />
                        <feGaussianBlur stdDeviation="1.5" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix type="matrix" values={colorMatrix} />
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_195_19609" />
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_195_19609" result="shape" />
                    </filter>
                    <clipPath id={clipId0}>
                        <rect width="44" height="44" rx="4" fill="white" style={{ fill: 'white', fillOpacity: 1 }} />
                    </clipPath>
                    <clipPath id={clipId1}>
                        <rect x="6" y="6" width="32" height="32" rx="4" fill="white" style={{ fill: 'white', fillOpacity: 1 }} />
                    </clipPath>
                </defs>
            </svg>
        );
    };

    private getImage18ptGlowSvg = (colorMatrix) => {
        const id = generate();
        const clipId0 = `clip0_${id}`;
        const clipId1 = `clip1_${id}`;
        const filterId = `filter_${id}`;
        return (
            <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath={`url(#${clipId0})`}>
                    <g filter={`url(#${filterId})`}>
                        <g clipPath={`url(#${clipId1})`}>
                            <rect x="6" y="6" width="32" height="32" rx="4" fill="white" style={{ fill: 'white', fillOpacity: 1 }} />
                            <path d="M6 10C6 7.79086 7.79086 6 10 6H34C36.2091 6 38 7.79086 38 10V34C38 36.2091 36.2091 38 34 38H10C7.79086 38 6 36.2091 6 34V10Z" fill="#EDF3FF" style={{ fill: '#EDF3FF', fillOpacity: 1 }} />
                            <path fillRule="evenodd" clipRule="evenodd" d="M34 7H10C8.34315 7 7 8.34315 7 10V34C7 35.6569 8.34315 37 10 37H34C35.6569 37 37 35.6569 37 34V10C37 8.34315 35.6569 7 34 7ZM10 6C7.79086 6 6 7.79086 6 10V34C6 36.2091 7.79086 38 10 38H34C36.2091 38 38 36.2091 38 34V10C38 7.79086 36.2091 6 34 6H10Z" fill="#9DC0FF" style={{ fill: '#9DC0FF', fillOpacity: 1 }} />
                            <path fillRule="evenodd" clipRule="evenodd" d="M16.1902 17.2631C17.7566 17.2631 19.0265 16.0275 19.0265 14.5033C19.0265 12.9791 17.7566 11.7435 16.1902 11.7435C14.6238 11.7435 13.3539 12.9791 13.3539 14.5033C13.3539 16.0275 14.6238 17.2631 16.1902 17.2631ZM16.7694 22.3066C16.8369 22.204 16.9856 22.1989 17.06 22.2966L20.626 26.9826C20.6991 27.0788 20.8448 27.0757 20.9139 26.9766L25.9783 19.711C26.0512 19.6063 26.2073 19.61 26.2752 19.718L34.5003 32.8039C34.5748 32.9226 34.4895 33.0769 34.3494 33.0769H10.0155C9.87369 33.0769 9.78873 32.9193 9.86664 32.8008L16.7694 22.3066Z" fill="#8BB4FF" fillOpacity="0.5" style={{ fill: '#8BB4FF', fillOpacity: 0.5 }} />
                        </g>
                    </g>
                </g>
                <defs>
                    <filter id={filterId} x="-1" y="-1" width="46" height="46" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                        <feMorphology radius="4" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_195_19612" />
                        <feOffset />
                        <feGaussianBlur stdDeviation="1.5" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix type="matrix" values={colorMatrix} />
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_195_19612" />
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_195_19612" result="shape" />
                    </filter>
                    <clipPath id={clipId0}>
                        <rect width="44" height="44" rx="4" fill="white" style={{ fill: 'white', fillOpacity: 1 }} />
                    </clipPath>
                    <clipPath id={clipId1}>
                        <rect x="6" y="6" width="32" height="32" rx="4" fill="white" style={{ fill: 'white', fillOpacity: 1 }} />
                    </clipPath>
                </defs>
            </svg>
        );
    };

    private getShape5ptGlowSvg = (colorMatrix) => {
        const id = generate();
        const clipId = `#clip${id}`;
        const filterId = `#filter${id}`;
        return (
            <svg width="44" height="45" viewBox="0 0 44 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter={`url(#${filterId})`}>
                    <g clipPath={`url(#${clipId})`}>
                        <rect x="6" y="6.29053" width="32" height="32" rx="4" fill="white" />
                        <rect x="6.5" y="6.79053" width="31" height="31" rx="3.5" fill="url(#paint0_linear_20_91468)" stroke="#CBCDD1" />
                        <path d="M6 10.2905C6 8.08139 7.79086 6.29053 10 6.29053H34C36.2091 6.29053 38 8.08139 38 10.2905V34.2905C38 36.4997 36.2091 38.2905 34 38.2905H10C7.79086 38.2905 6 36.4997 6 34.2905V10.2905Z" fill="url(#paint1_linear_20_91468)" />
                        <path fillRule="evenodd" clipRule="evenodd" d="M34 7.29053H10C8.34315 7.29053 7 8.63367 7 10.2905V34.2905C7 35.9474 8.34315 37.2905 10 37.2905H34C35.6569 37.2905 37 35.9474 37 34.2905V10.2905C37 8.63367 35.6569 7.29053 34 7.29053ZM10 6.29053C7.79086 6.29053 6 8.08139 6 10.2905V34.2905C6 36.4997 7.79086 38.2905 10 38.2905H34C36.2091 38.2905 38 36.4997 38 34.2905V10.2905C38 8.08139 36.2091 6.29053 34 6.29053H10Z" fill="#CBCDD1" />
                    </g>
                </g>
                <defs>
                    <filter id={filterId} x="2" y="2.29053" width="40" height="40" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                        <feMorphology radius="1" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_20_91468" />
                        <feOffset />
                        <feGaussianBlur stdDeviation="1.5" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix type="matrix" values={colorMatrix} />
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_20_91468" />
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_20_91468" result="shape" />
                    </filter>
                    <linearGradient id="paint0_linear_20_91468" x1="21.9946" y1="6.42229" x2="21.9946" y2="38.4223" gradientUnits="userSpaceOnUse">
                        <stop stopColor="white" />
                        <stop offset="1" stopColor="#E9E9E9" />
                    </linearGradient>
                    <linearGradient id="paint1_linear_20_91468" x1="21.9946" y1="6.42229" x2="21.9946" y2="38.4223" gradientUnits="userSpaceOnUse">
                        <stop stopColor="white" />
                        <stop offset="1" stopColor="#E9E9E9" />
                    </linearGradient>
                    <clipPath id={clipId}>
                        <rect x="6" y="6.29053" width="32" height="32" rx="4" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        );
    };
    private getShape8ptGlowSvg = (colorMatrix) => {
        const id = generate();
        const clipId = `#clip${id}`;
        const filterId = `#filter${id}`;
        const paintId = `paint_linear_${id}`;
        return  <svg width="44" height="45" viewBox="0 0 44 45" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter={`url(#${filterId})`}>
                <g clipPath={`url(#${clipId})`}>
                    <rect x="6" y="6.29053" width="32" height="32" rx="4" fill="white"/>
                    <path d="M6 10.2905C6 8.08139 7.79086 6.29053 10 6.29053H34C36.2091 6.29053 38 8.08139 38 10.2905V34.2905C38 36.4997 36.2091 38.2905 34 38.2905H10C7.79086 38.2905 6 36.4997 6 34.2905V10.2905Z" fill={`url(#${paintId})`}/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M34 7.29053H10C8.34315 7.29053 7 8.63367 7 10.2905V34.2905C7 35.9474 8.34315 37.2905 10 37.2905H34C35.6569 37.2905 37 35.9474 37 34.2905V10.2905C37 8.63367 35.6569 7.29053 34 7.29053ZM10 6.29053C7.79086 6.29053 6 8.08139 6 10.2905V34.2905C6 36.4997 7.79086 38.2905 10 38.2905H34C36.2091 38.2905 38 36.4997 38 34.2905V10.2905C38 8.08139 36.2091 6.29053 34 6.29053H10Z" fill="#CBCDD1"/>
                </g>
            </g>
            <defs>
                <filter id={filterId} x="1" y="1.29053" width="42" height="42" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_20_91469"/>
                    <feOffset/>
                    <feGaussianBlur stdDeviation="1.5"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values={colorMatrix} />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_20_91469"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_20_91469" result="shape"/>
                </filter>
                <linearGradient id={paintId} x1="21.9946" y1="6.42229" x2="21.9946" y2="38.4223" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white"/>
                    <stop offset="1" stopColor="#E9E9E9"/>
                </linearGradient>
                <clipPath id={clipId}>
                    <rect x="6" y="6.29053" width="32" height="32" rx="4" fill="white"/>
                </clipPath>
            </defs>
        </svg>;
    };
    private getShape11ptGlowSvg = (colorMatrix) => {
        const id = generate();
        const clipId0 = `clip0_${id}`;
        const clipId1 = `clip1_${id}`;
        const filterId = `filter0_d_${id}`;
        const paintId = `paint0_linear_${id}`;
        return <svg width="44" height="45" viewBox="0 0 44 45" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath={`url(#${clipId0})`}>
                <g filter={`url(#${filterId})`}>
                    <g clipPath={`url(#${clipId1})`}>
                        <rect x="6" y="6.29053" width="32" height="32" rx="4" fill="white" />
                        <path d="M6 10.2905C6 8.08139 7.79086 6.29053 10 6.29053H34C36.2091 6.29053 38 8.08139 38 10.2905V34.2905C38 36.4997 36.2091 38.2905 34 38.2905H10C7.79086 38.2905 6 36.4997 6 34.2905V10.2905Z" fill={`url(#${paintId})`} />
                        <path fillRule="evenodd" clipRule="evenodd" d="M34 7.29053H10C8.34315 7.29053 7 8.63367 7 10.2905V34.2905C7 35.9474 8.34315 37.2905 10 37.2905H34C35.6569 37.2905 37 35.9474 37 34.2905V10.2905C37 8.63367 35.6569 7.29053 34 7.29053ZM10 6.29053C7.79086 6.29053 6 8.08139 6 10.2905V34.2905C6 36.4997 7.79086 38.2905 10 38.2905H34C36.2091 38.2905 38 36.4997 38 34.2905V10.2905C38 8.08139 36.2091 6.29053 34 6.29053H10Z" fill="#CBCDD1" />
                    </g>
                </g>
            </g>
            <defs>
                <filter id={filterId} x="0" y="0.290527" width="44" height="44" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feMorphology radius="3" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_${id}" />
                    <feOffset />
                    <feGaussianBlur stdDeviation="1.5" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values={colorMatrix} />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_${id}" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_${id}" result="shape" />
                </filter>
                <linearGradient id={paintId} x1="21.9946" y1="6.42229" x2="21.9946" y2="38.4223" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#E9E9E9" />
                </linearGradient>
                <clipPath id={clipId0}>
                    <rect y="0.290527" width="44" height="44" rx="4" fill="white" />
                </clipPath>
                <clipPath id={clipId1}>
                    <rect x="6" y="6.29053" width="32" height="32" rx="4" fill="white" />
                </clipPath>
            </defs>
        </svg>;
    };
    private getShape18ptGlowSvg = (colorMatrix) => {
        const id = generate();
        const clipId0 = `clip0_${id}`;
        const clipId1 = `clip1_${id}`;
        const filterId = `filter0_d_${id}`;
        const paintId = `paint0_linear_${id}`;

        return (
            <svg width="44" height="45" viewBox="0 0 44 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath={`url(#${clipId0})`}>
                    <g filter={`url(#${filterId})`}>
                        <g clipPath={`url(#${clipId1})`}>
                            <rect x="6" y="6.29053" width="32" height="32" rx="4" fill="white" />
                            <path d="M6 10.2905C6 8.08139 7.79086 6.29053 10 6.29053H34C36.2091 6.29053 38 8.08139 38 10.2905V34.2905C38 36.4997 36.2091 38.2905 34 38.2905H10C7.79086 38.2905 6 36.4997 6 34.2905V10.2905Z" fill={`url(#${paintId})`} />
                            <path fillRule="evenodd" clipRule="evenodd" d="M34 7.29053H10C8.34315 7.29053 7 8.63367 7 10.2905V34.2905C7 35.9474 8.34315 37.2905 10 37.2905H34C35.6569 37.2905 37 35.9474 37 34.2905V10.2905C37 8.63367 35.6569 7.29053 34 7.29053ZM10 6.29053C7.79086 6.29053 6 8.08139 6 10.2905V34.2905C6 36.4997 7.79086 38.2905 10 38.2905H34C36.2091 38.2905 38 36.4997 38 34.2905V10.2905C38 8.08139 36.2091 6.29053 34 6.29053H10Z" fill="#CBCDD1" />
                        </g>
                    </g>
                </g>
                <defs>
                    <filter id={filterId} x="-1" y="-0.709473" width="46" height="46" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                        <feMorphology radius="4" operator="dilate" in="SourceAlpha" result={`effect1_dropShadow_${id}`} />
                        <feOffset />
                        <feGaussianBlur stdDeviation="1.5" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix type="matrix" values={colorMatrix} />
                        <feBlend mode="normal" in2="BackgroundImageFix" result={`effect1_dropShadow_${id}`} />
                        <feBlend mode="normal" in="SourceGraphic" in2={`effect1_dropShadow_${id}`} result="shape" />
                    </filter>
                    <linearGradient id={paintId} x1="21.9946" y1="6.42229" x2="21.9946" y2="38.4223" gradientUnits="userSpaceOnUse">
                        <stop stopColor="white" />
                        <stop offset="1" stopColor="#E9E9E9" />
                    </linearGradient>
                    <clipPath id={clipId0}>
                        <rect y="0.290527" width="44" height="44" rx="4" fill="white" />
                    </clipPath>
                    <clipPath id={clipId1}>
                        <rect x="6" y="6.29053" width="32" height="32" rx="4" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        );
    };

    private getText5ptGlowSvg = (hex) => {
        const id = generate();
        const filterId = `filter0_f_${id}`;
        const paintId = `paint0_linear_${id}`;
        return (
            <svg width="44" height="45" viewBox="0 0 44 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter={`url(#${filterId})`}>
                    <path fillRule="evenodd" clipRule="evenodd" d="M38 38.2905L25.5463 6.29053H18.4537L6 38.2905H13.5676L16.3415 30.7857H27.6585L30.4324 38.2905H38ZM22.0174 15.3834L25.4093 24.6962H18.5952L22.0174 15.3834Z" fill={hex} fillOpacity="0.48" />
                </g>
                <path fillRule="evenodd" clipRule="evenodd" d="M19.1622 7.32275H24.838L36.4883 37.2582H31.1539L28.38 29.7534H15.6202L12.8463 37.2582H7.51196L19.1622 7.32275ZM17.1138 25.7285H26.8864L22.1068 12.6055H21.9361L17.1138 25.7285Z" fill={`url(#${paintId})`} />
                <path fillRule="evenodd" clipRule="evenodd" d="M18.9058 6.94775H25.0945L37.0366 37.6332H30.8927L28.1188 30.1284H15.8814L13.1075 37.6332H6.96362L18.9058 6.94775ZM19.4187 7.69775L8.0603 36.8832H12.5851L15.359 29.3784H28.6412L31.4151 36.8832H35.9399L24.5815 7.69775H19.4187ZM21.6744 12.2305H22.3693L27.4221 26.1035H16.5765L21.6744 12.2305ZM22.0203 13.4637L17.6512 25.3535H26.3507L22.0203 13.4637Z" fill="#DCDCDC" />
                <defs>
                    <filter id={filterId} x="3" y="3.29053" width="38" height="38" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                        <feGaussianBlur stdDeviation="1.5" result="effect1_foregroundBlur_20_77660" />
                    </filter>
                    <linearGradient id={paintId} x1="22.0001" y1="7.32275" x2="22.0001" y2="37.2582" gradientUnits="userSpaceOnUse">
                        <stop stopColor="white" />
                        <stop offset="1" stopColor="#E4E4E4" />
                    </linearGradient>
                </defs>
            </svg>
        );
    };
    private getText8ptGlowSvg = (hex) => {
        const id = generate();
        const filterId = `filter0_f_${id}`;
        const paintId = `paint0_linear_${id}`;

        return (
            <svg width="44" height="45" viewBox="0 0 44 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter={`url(#${filterId})`}>
                    <path fillRule="evenodd" clipRule="evenodd" d="M38 38.2905L25.5463 6.29053H18.4537L6 38.2905H13.5676L16.3415 30.7857H27.6585L30.4324 38.2905H38ZM22.0174 15.3834L25.4093 24.6962H18.5952L22.0174 15.3834Z" fill={hex} fillOpacity="0.48" />
                    <path d="M26.0122 6.10919L25.8882 5.79053H25.5463H18.4537H18.1118L17.9878 6.10919L5.53404 38.1092L5.26888 38.7905H6H13.5676H13.9159L14.0366 38.4639L16.6898 31.2857H27.3102L29.9634 38.4639L30.0841 38.7905H30.4324H38H38.7311L38.466 38.1092L26.0122 6.10919ZM19.3117 24.1962L22.0153 16.8387L24.695 24.1962H19.3117Z" stroke={hex} strokeOpacity="0.48" />
                </g>
                <path fillRule="evenodd" clipRule="evenodd" d="M19.1622 7.32275H24.838L36.4883 37.2582H31.1539L28.38 29.7534H15.6202L12.8463 37.2582H7.51196L19.1622 7.32275ZM17.1138 25.7285H26.8864L22.1068 12.6055H21.9361L17.1138 25.7285Z" fill={`url(#${paintId})`} />
                <path fillRule="evenodd" clipRule="evenodd" d="M18.9058 6.94775H25.0945L37.0366 37.6332H30.8927L28.1188 30.1284H15.8814L13.1075 37.6332H6.96362L18.9058 6.94775ZM19.4187 7.69775L8.0603 36.8832H12.5851L15.359 29.3784H28.6412L31.4151 36.8832H35.9399L24.5815 7.69775H19.4187ZM21.6744 12.2305H22.3693L27.4221 26.1035H16.5765L21.6744 12.2305ZM22.0203 13.4637L17.6512 25.3535H26.3507L22.0203 13.4637Z" fill="#DCDCDC" />
                <defs>
                    <filter id={filterId} x="1.53784" y="2.29053" width="40.9243" height="40" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                        <feGaussianBlur stdDeviation="1.5" result="effect1_foregroundBlur_20_77661" />
                    </filter>
                    <linearGradient id={paintId} x1="22.0001" y1="7.32275" x2="22.0001" y2="37.2582" gradientUnits="userSpaceOnUse">
                        <stop stopColor="white" />
                        <stop offset="1" stopColor="#E4E4E4" />
                    </linearGradient>
                </defs>
            </svg>
        );
    };
    private getText11ptGlowSvg = (hex) => {
        const id = generate();
        const filterId = `filter0_f_${id}`;
        const paintId = `paint0_linear_${id}`;
        return (
            <svg width="44" height="45" viewBox="0 0 44 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter={`url(#${filterId})`}>
                    <path fillRule="evenodd" clipRule="evenodd" d="M38 38.2905L25.5463 6.29053H18.4537L6 38.2905H13.5676L16.3415 30.7857H27.6585L30.4324 38.2905H38ZM22.0174 15.3834L25.4093 24.6962H18.5952L22.0174 15.3834Z" fill={hex} fillOpacity="0.48" />
                    <path d="M26.0122 6.10919L25.8882 5.79053H25.5463H18.4537H18.1118L17.9878 6.10919L5.53404 38.1092L5.26888 38.7905H6H13.5676H13.9159L14.0366 38.4639L16.6898 31.2857H27.3102L29.9634 38.4639L30.0841 38.7905H30.4324H38H38.7311L38.466 38.1092L26.0122 6.10919ZM19.3117 24.1962L22.0153 16.8387L24.695 24.1962H19.3117Z" stroke={hex} strokeOpacity="0.48" />
                </g>
                <path fillRule="evenodd" clipRule="evenodd" d="M19.1622 7.32275H24.838L36.4883 37.2582H31.1539L28.38 29.7534H15.6202L12.8463 37.2582H7.51196L19.1622 7.32275ZM17.1138 25.7285H26.8864L22.1068 12.6055H21.9361L17.1138 25.7285Z" fill={`url(#${paintId})`} />
                <path fillRule="evenodd" clipRule="evenodd" d="M18.9058 6.94775H25.0945L37.0366 37.6332H30.8927L28.1188 30.1284H15.8814L13.1075 37.6332H6.96362L18.9058 6.94775ZM19.4187 7.69775L8.0603 36.8832H12.5851L15.359 29.3784H28.6412L31.4151 36.8832H35.9399L24.5815 7.69775H19.4187ZM21.6744 12.2305H22.3693L27.4221 26.1035H16.5765L21.6744 12.2305ZM22.0203 13.4637L17.6512 25.3535H26.3507L22.0203 13.4637Z" fill="#DCDCDC" />
                <defs>
                    <filter id={filterId} x="1.53784" y="2.29053" width="40.9243" height="40" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                        <feGaussianBlur stdDeviation="1.5" result="effect1_foregroundBlur_20_77661" />
                    </filter>
                    <linearGradient id={paintId} x1="22.0001" y1="7.32275" x2="22.0001" y2="37.2582" gradientUnits="userSpaceOnUse">
                        <stop stopColor="white" />
                        <stop offset="1" stopColor="#E4E4E4" />
                    </linearGradient>
                </defs>
            </svg>
        );
    };
    private getText18ptGlowSvg = (hex) => {
        const id = generate();
        const filterId = `filter0_f_${id}`;
        const paintId = `paint0_linear_${id}`;
        const clipId = `clip0_${id}`;

        return (
            <svg width="44" height="45" viewBox="0 0 44 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath={`url(#${clipId})`}>
                    <g filter={`url(#${filterId})`}>
                        <path fillRule="evenodd" clipRule="evenodd" d="M38 38.2905L25.5463 6.29053H18.4537L6 38.2905H13.5676L16.3415 30.7857H27.6585L30.4324 38.2905H38ZM22.0174 15.3834L25.4093 24.6962H18.5952L22.0174 15.3834Z" fill={hex} fillOpacity="0.48" />
                        <path d="M14.9746 38.8106L17.3863 32.2857H26.6137L29.0254 38.8106L29.3876 39.7905H30.4324H38H40.1934L39.3979 37.7465L26.9441 5.74651L26.5721 4.79053H25.5463H18.4537H17.4279L17.0559 5.74651L4.60213 37.7465L3.80664 39.7905H6H13.5676H14.6124L14.9746 38.8106ZM22.0111 19.7493L23.2666 23.1962H20.7445L22.0111 19.7493Z" stroke={hex} strokeOpacity="0.48" strokeWidth="3" />
                    </g>
                    <path fillRule="evenodd" clipRule="evenodd" d="M19.1622 7.32275H24.838L36.4883 37.2582H31.1539L28.38 29.7534H15.6202L12.8463 37.2582H7.51196L19.1622 7.32275ZM17.1138 25.7285H26.8864L22.1068 12.6055H21.9361L17.1138 25.7285Z" fill={`url(#${paintId})`} />
                    <path fillRule="evenodd" clipRule="evenodd" d="M18.9058 6.94775H25.0945L37.0366 37.6332H30.8927L28.1188 30.1284H15.8814L13.1075 37.6332H6.96362L18.9058 6.94775ZM19.4187 7.69775L8.0603 36.8832H12.5851L15.359 29.3784H28.6412L31.4151 36.8832H35.9399L24.5815 7.69775H19.4187ZM21.6744 12.2305H22.3693L27.4221 26.1035H16.5765L21.6744 12.2305ZM22.0203 13.4637L17.6512 25.3535H26.3507L22.0203 13.4637Z" fill="#DCDCDC" />
                </g>
                <defs>
                    <filter id={filterId} x="-1.38672" y="0.290527" width="46.7734" height="44" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                        <feGaussianBlur stdDeviation="1.5" result="effect1_foregroundBlur_20_77663" />
                    </filter>
                    <linearGradient id={paintId} x1="22.0001" y1="7.32275" x2="22.0001" y2="37.2582" gradientUnits="userSpaceOnUse">
                        <stop stopColor="white" />
                        <stop offset="1" stopColor="#E4E4E4" />
                    </linearGradient>
                    <clipPath id={clipId}>
                        <rect y="0.290527" width="44" height="44" rx="4" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        );
    };
}
